(ns teamoesterreich.actions.backend-requests
  (:require
    [shadow.cljs.modern :refer (js-await)]
    [teamoesterreich.config :as config]
    [teamoesterreich.user-mode.backend :as backend]
    ))

(defn send-lebensretter-link [done-fn & [failed-fn]]
  (js-await [user (.getUser ^js config/user-manager)]
    (js-await [response (js/fetch (str backend/BASE_URL "/send-lebensretter-welcome-mail")
                                  #js{:method  "POST"
                                      :headers (clj->js (merge {}
                                                               (when user {:Authorization (str "Bearer " (.-access_token user))})))})]
      (when (.-ok response)
        (done-fn)))))

(defn get-lebensretter-link [done-fn]
  (js-await [user (.getUser ^js config/user-manager)]
    (js-await [response (js/fetch (str backend/BASE_URL "/get-lebensretter-link")
                                  #js{:method  "POST"
                                      :headers (clj->js (merge {}
                                                               (when user {:Authorization (str "Bearer " (.-access_token user))})))})]
      (if (.-ok response)
        (js-await [body (.text response)]
          (done-fn body))))))

(defn send-lebensretter-selfexplain-link [done-fn & [failed-fn]]
  (js-await [user (.getUser ^js config/user-manager)]
    (js-await [response (js/fetch (str backend/BASE_URL "/get-lebensretter-selfexplain-link")
                                  #js{:method  "POST"
                                      :headers (clj->js (merge {}
                                                               (when user {:Authorization (str "Bearer " (.-access_token user))})))})]
      (if (.-ok response)
        (js-await [body (.text response)]
          (done-fn body))))))

(defn sync-firestore []
  (js-await [user (.getUser ^js config/user-manager)]
    (js-await [response (js/fetch (str backend/BASE_URL "/sync-firestore")
                                  #js{:method  "POST"
                                      :headers (clj->js (merge {}
                                                               (when user {:Authorization (str "Bearer " (.-access_token user))})))})]
      (.-ok response))))


(defn set-user-crowdtasker-response [tom-id event-uuid data done-fn & [failed-fn]]
  (js-await [user (.getUser ^js config/user-manager)]
            (js-await [response (js/fetch (str backend/BASE_URL "/set-user-crowdtasker-response?event-uuid=" event-uuid "&tom-id=" tom-id)
                                          #js{:method  "POST"
                                              :body (js/JSON.stringify (clj->js data))
                                              :headers (clj->js (merge {}
                                                                       (when user {:Authorization (str "Bearer " (.-access_token user))})))})]
                      (if (.-ok response)
                        (js-await [body (.text response)]
                                  (done-fn body))))))

(defn get-user-crowdtasker-response [eventUuid tomId done-fn & [failed-fn]]
  (js-await [user (.getUser ^js config/user-manager)]
            (js-await [response (js/fetch (str backend/BASE_URL "/get-user-crowdtasker-response?event-uuid=" eventUuid "&tom-id=" tomId)
                                          #js{:method  "GET"
                                              :headers (clj->js (merge {}
                                                                       (when user {:Authorization (str "Bearer " (.-access_token user))})))})]
                      (if (.-ok response)
                        (js-await [body (.json response)]
                                  (done-fn (js->clj body {:keywordize-keys true})))))))









